var _path, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7012 24.4375V42.1799C17.7012 43.8844 18.3318 46.4154 21.4417 46.4154C24.5517 46.4154 25.3447 43.8844 25.3447 42.1799V30.8867C25.3447 29.8516 25.8701 27.7815 27.9721 27.7815C30.0741 27.7815 31.1028 27.7815 31.6601 27.7815",
    stroke: "#FF8165",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8237 15.9961C11.4278 20.0325 14.2063 23.3165 18.4471 23.3165C21.638 23.3165 24.3068 20.3146 25.2121 15.9961",
    stroke: "#1552E8",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2803 24.4375V42.1799C18.2803 43.8844 18.9109 46.4154 22.0208 46.4154C25.1308 46.4154 25.9238 43.8844 25.9238 42.1799V30.8867C25.9238 29.8516 26.4492 27.7815 28.5512 27.7815C30.6532 27.7815 31.6819 27.7815 32.2392 27.7815",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3984 6.30469V16.0979C10.4781 18.805 12.1182 24.2191 18.0419 24.2191C23.9656 24.2191 25.6058 18.805 25.6854 16.0979V6.30469",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4019 13.9922C11.2777 15.7438 14.0325 19.2471 18.0453 19.2471C22.0582 19.2471 24.813 15.7438 25.6888 13.9922",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3988,
    cy: 4.14192,
    r: 2.89973,
    fill: "#F6F8FE",
    stroke: "#081E54",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6868 7.04165C27.2883 7.04165 28.5866 5.7434 28.5866 4.14192C28.5866 2.54044 27.2883 1.24219 25.6868 1.24219C24.0854 1.24219 22.7871 2.54044 22.7871 4.14192C22.7871 5.7434 24.0854 7.04165 25.6868 7.04165Z",
    fill: "#F6F8FE",
    stroke: "#081E54",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.7935,
    cy: 27.7652,
    r: 3.08755,
    stroke: "#081E54",
    strokeWidth: 0.933333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.8119,
    cy: 27.7382,
    r: 2.01942,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors);
export default __webpack_public_path__ + "static/media/Doctors.f4505431f948de31b633fd38e9baf876.svg";
export { ForwardRef as ReactComponent };